export default "__VITE_PUBLIC_ASSET__dcabcb59__"